<section>
    <div class="container-fluid">
        <div class="row mb-1">

            <div class="col-sm-10 p-0">
                <div class="container-fluid">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">Home</li>
                        <li class="breadcrumb-item">Admin</li>
                        <li class="breadcrumb-item active">Search Theme Users Assign</li>
                    </ol>
                </div>
            </div>
        </div>
    </div>
</section>
<section>
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-12 p-0">
                <div class="card Title-bar-blue">
                    <div class="devcare-card-header">
                        <span class="devcare-sub-header Title-bar-text"><i class="fas fa-search mr-1"></i> Search Theme
                            Users Assign</span>
                        <button *ngIf="sharedService.checkPermission('Admin_Add')" style="height: 30px !important;width: auto!important;
                        margin-top: -2px;border-color: white;" pButton type="button" icon="pi pi-plus" label="Add"
                            class="p-button-sm p-button-success float-right" (click)="addUserAssignDetails()"></button>
                        &nbsp;&nbsp;
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section>
    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="devcare-card-body">
                    <div class="row">
                        <div class="col-md-4">
                            <button [ngClass]="showSorting === true ? 'p-button-raised m-2' : 'p-button-outlined m-2'"
                                pButton type="button" icon="pi pi-fw pi-sort-alt" (click)="bindShowSorting()"
                                [loading]="isSearchLoading" style="float: left;height: 30px;"></button>

                            <button [ngClass]="showFilters === true ? 'p-button-raised m-2' : 'p-button-outlined m-2'"
                                pButton type="button" icon="fas fa-filter" (click)="bindShowFilter()"
                                [loading]="isSearchLoading" style="float: left;height: 30px;"></button>

                            <button [ngClass]="showToggle === true ? 'p-button-raised m-2' : 'p-button-outlined m-2'"
                                pButton type="button" icon="pi pi-list" (click)="bindShowToggle()"
                                [loading]="isSearchLoading" style="float: left;height: 30px;"></button>

                        </div>
                        <div class="col-md-8">

                            <!-- <button pButton label="Export" (click)="exportSearchPageThemeUsersAssign()"class="p-button-raised  m-2" icon="pi pi-file-excel"
                                type="button" style="float: right;height: 30px;"></button> -->

                            <button pButton label="Clear" class="p-button-raised m-2" icon="pi pi-filter-slash"
                                (click)="clearFilter(dt2)" style="float: right;height: 30px;"></button>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section>
    <div class="row">
        <div class="col-md-12">
            <div class="row">
                <div class="col-md-12" *ngIf="isUserAdd">
                    <div class="card">
                        <div class="devcare-card-header">
                            <span class="devcare-card-title">Search Theme Users Assign</span>
                        </div>
                        <div class="devcare-card-body">
                            <div class="row">
                                <div class="col-md-9">
                                    <form [formGroup]="">
                                        <div class="p-fluid p-formgrid p-grid">
                                            <div class="p-field p-col-12 p-md-4" *ngIf=isPageddDisabled>
                                                <label for="searchPageName">Search Page <span
                                                        class="required-field">*</span></label>
                                                <p-dropdown (onChange)="getSearchPageNameOnChange($event)"  
                                                    [options]="searchPageNamesList" placeholder="Select a Search Page" [disabled]=true
                                                    optionLabel="description" optionValue="lookupOrder"
                                                    [(ngModel)]="searchPageNameLkId"
                                                    [ngModelOptions]="{standalone: true}">
                                                </p-dropdown>

                                            </div>
                                            <div class="p-field p-col-12 p-md-4" *ngIf=!isPageddDisabled>
                                                <label for="searchPageName">Search Page <span
                                                        class="required-field">*</span></label>
                                                <p-dropdown (onChange)="getSearchPageNameOnChange($event)"  
                                                    [options]="searchPageNamesList" placeholder="Select a Search Page" 
                                                    optionLabel="description" optionValue="lookupOrder"
                                                    [(ngModel)]="searchPageNameLkId"
                                                    [ngModelOptions]="{standalone: true}">
                                                </p-dropdown>

                                            </div>
                                            <div class="p-field p-col-12 p-md-4" *ngIf=isThemeddDisabled>
                                                <label for="theme">Theme<span class="required-field">*</span></label>
                                                <p-dropdown (onChange)="getSearchThemeNameOnChange($event)"   [(ngModel)]="searchThemeId"
                                                [ngModelOptions]="{standalone: true}"
                                                    [options]="searchPageThemesList" placeholder="Select a Theme" [disabled]=true
                                                    optionLabel="themeName" optionValue="themeId">
                                                </p-dropdown>
                                            </div>
                                            <div class="p-field p-col-12 p-md-4" *ngIf=!isThemeddDisabled>
                                                <label for="theme">Theme<span class="required-field">*</span></label>
                                                <p-dropdown (onChange)="getSearchThemeNameOnChange($event)"   [(ngModel)]="searchThemeId"
                                                [ngModelOptions]="{standalone: true}"
                                                    [options]="searchPageThemesList" placeholder="Select a Theme" 
                                                    optionLabel="themeName" optionValue="themeId">
                                                </p-dropdown>
                                            </div>
                                            <div class="p-field p-col-12 p-md-4">
                                                <label>User<span class="required-field">*</span></label>
                                                <p-multiSelect #multiSelect [options]="usersList"
                                                    (onChange)="getUserListsOnChange($event)" [(ngModel)]="userIds"
                                                    [ngModelOptions]="{standalone: true}"
                                                    defaultLabel={{selectedItems}} optionLabel="fullName"
                                                    display="chip"></p-multiSelect>
                                            </div>

                                        </div>

                                    </form>
                                </div>
                                <div class="col-md-3 d-flex align-items-center">
                                    <button pButton pRipple type="button" [disabled]="themeAlreadyExist || isPageSelected || isThemeSelected || isUserSelected" (click)="updateThemeUsersAssignList()" label="{{buttonLabel}}" icon="pi pi-check"
                                        class="p-button-sm p-button-raised p-button-success m-2"></button>
                                    <button pButton pRipple type="button" (click)="cancelThemeUsersAssign()" label="Cancel" icon="pi pi-times"
                                        class="p-button-sm p-button-raised p-button-danger m-2"></button>

                                </div>
                            </div>

                        </div>

                    </div>
                </div>
                <div class="col-md-12">
                    <div class="card">
                        <!-- <div class="devcare-table-card-header">
                            <div class="row">
                                <div class="col-md-6">
                                    <button pButton type="button" class="p-button-raised p-button-sm m-2" label="Add"
                                    icon="pi pi-plus" (click)="addVcaDetails()" *ngIf="(isVcaAdd === false) && sharedService.checkPermission('Admin_Add')"></button>
                                </div>
                                <div class="col-md-6">
                                   
                                </div>
                            </div>
                        </div> -->
                        <div class="devcare-table-card-header" *ngIf="showToggle">
                            <div class="row">
                                <div class="col-md-6">

                                </div>
                                <div class="col-md-6">
                                    <p-multiSelect *ngIf="showToggle" [options]="allColumns"
                                        [(ngModel)]="selectedColumns" maxSelectedLabels="0" dropdownIcon="pi pi-list"
                                        selectedItemsLabel="{0} columns selected" optionLabel="header"
                                        [showHeader]="false" [showClear]="false" (onChange)="showAndHideColumn($event)"
                                        style="float: right;">
                                        <ng-template let-column pTemplate="item">
                                            <div class="column-item">
                                                <div>{{column.header}}</div>
                                            </div>
                                        </ng-template>
                                    </p-multiSelect>
                                </div>
                            </div>
                        </div>
                        <div class="card-body devcare-table-card-body" style="overflow: hidden;">
                            <p-table #dt2 [value]="searchPageThemeUsersList" [lazy]="true"
                                paginatorDropdownAppendTo="body" (onLazyLoad)="loadThemeUsersList($event)" dataKey="id"
                                [rows]="10" [showCurrentPageReport]="true" [resizableColumns]="true"
                                columnResizeMode="expand" [rowsPerPageOptions]="[10,25,50]" [loading]="loading"
                                styleClass="p-datatable-gridlines" [paginator]="isshowpaginator"
                                [totalRecords]="totalRecords"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                [globalFilterFields]="['searchPageName','themeName','description', 'createdBy', 'modifiedBy']">

                                <ng-template pTemplate="header">
                                    <tr>
                                        <th pResizableColumn style="width: 5rem" *ngIf="isShowColumns('action')">Action
                                        </th>
                                        <th pResizableColumn *ngIf="isShowColumns('searchPageName')">Search Page Name<span pSortableColumn="searchPageName" *ngIf="showSorting">
                                                <p-sortIcon field="searchPageName"></p-sortIcon>
                                            </span>
                                            <p-columnFilter [hidden]="!showFilters" type="text" field="searchPageName" #filterSearchPageName
                                                display="menu" [showAddButton]="false" [showOperator]="false"
                                                [matchModeOptions]="matchModeOptions" [showClearButton]="false"
                                                [showApplyButton]="false">
                                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                                    <input #searchPageName type="text"
                                                        value="{{filters?.searchPageName[0]?.value}}" pInputText
                                                        class="pinputHeight">
                                                    <div class="p-d-flex p-jc-between p-ai-center p-mt-1">
                                                        <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-danger"
                                                            (onClick)="filter(undefined);applyFilterNew(dt2)">Clear
                                                        </p-button>
                                                        <p-button pRipple
                                                            styleClass="btn-height p-mt-2 p-p-2 bg-success"
                                                            (onClick)="filter(searchPageName.value);applyFilterNew(dt2);filterSearchPageName.hide()">
                                                            Apply</p-button>
                                                    </div>
                                                </ng-template>
                                            </p-columnFilter>
                                        </th>
                                        <th pResizableColumn *ngIf="isShowColumns('themeName')">Theme Name
                                            <span pSortableColumn="themeName" *ngIf="showSorting">
                                                <p-sortIcon field="themeName"></p-sortIcon>
                                            </span>
                                            <p-columnFilter [hidden]="!showFilters" type="text" field="themeName" #filterThemeName
                                                display="menu" [showAddButton]="false" [showOperator]="false"
                                                [matchModeOptions]="matchModeOptions" [showClearButton]="false"
                                                [showApplyButton]="false">
                                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                                    <input #themeName type="text"
                                                        value="{{filters?.themeName[0]?.value}}" pInputText
                                                        class="pinputHeight">
                                                    <div class="p-d-flex p-jc-between p-ai-center p-mt-1">
                                                        <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-danger"
                                                            (onClick)="filter(undefined);applyFilterNew(dt2)">Clear
                                                        </p-button>
                                                        <p-button pRipple
                                                            styleClass="btn-height p-mt-2 p-p-2 bg-success"
                                                            (onClick)="filter(themeName.value);applyFilterNew(dt2);filterThemeName.hide()">
                                                            Apply</p-button>
                                                    </div>
                                                </ng-template>
                                            </p-columnFilter>
                                        </th>
                                        <!-- <th>User Name</th> -->
                                        <th pResizableColumn *ngIf="isShowColumns('description')">User Name
                                            <!-- <span pSortableColumn="description" *ngIf="showSorting">
                                                <p-sortIcon field="description"></p-sortIcon>
                                            </span>
                                            <p-columnFilter *ngIf="showFilters" type="text" field="description"
                                                display="menu" [showAddButton]="false" [showOperator]="false"
                                                [matchModeOptions]="matchModeOptions" [showClearButton]="false"
                                                [showApplyButton]="false">
                                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                                    <input #description type="text"
                                                        value="{{filters?.description[0]?.value}}" pInputText
                                                        class="pinputHeight">
                                                    <div class="p-d-flex p-jc-between p-ai-center p-mt-1">
                                                        <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-danger"
                                                            (onClick)="filter(undefined);applyFilterNew(dt2)">Clear
                                                        </p-button>
                                                        <p-button pRipple
                                                            styleClass="btn-height p-mt-2 p-p-2 bg-success"
                                                            (onClick)="filter(description.value);applyFilterNew(dt2)">
                                                            Apply</p-button>
                                                    </div>
                                                </ng-template>
                                            </p-columnFilter> -->
                                        </th>


                                        <th pResizableColumn *ngIf="isShowColumns('createdBy')">Created By <span
                                                pSortableColumn="createdBy" *ngIf="showSorting">
                                                <p-sortIcon field="createdBy"></p-sortIcon>
                                            </span>
                                            <p-columnFilter [hidden]="!showFilters" field="createdBy" display="menu" #filterCreatedBy
                                                [showAddButton]="false" [showMatchModes]="true"
                                                [matchModeOptions]="matchModeOptions" [showOperator]="false"
                                                [showClearButton]="false" [showApplyButton]="false">
                                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                                    <input #createdBy type="text"
                                                        value="{{filters?.createdBy[0]?.value}}" pInputText
                                                        class="pinputHeight">
                                                    <div class="p-d-flex p-jc-between p-ai-center p-mt-1">
                                                        <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-danger"
                                                            (onClick)="filter(undefined);applyFilterNew(dt2)">Clear
                                                        </p-button>
                                                        <p-button pRipple
                                                            styleClass="btn-height p-mt-2 p-p-2 bg-success"
                                                            (onClick)="filter(createdBy.value);applyFilterNew(dt2);filterCreatedBy.hide()">
                                                            Apply</p-button>
                                                    </div>
                                                </ng-template>
                                            </p-columnFilter>
                                        </th>

                                        <th pResizableColumn *ngIf="isShowColumns('modifiedBy')">Modified By <span
                                                pSortableColumn="modifiedBy" *ngIf="showSorting">
                                                <p-sortIcon field="modifiedBy"></p-sortIcon>
                                            </span>
                                            <p-columnFilter [hidden]="!showFilters" field="modifiedBy" display="menu" #filterModifiedBy
                                                [showAddButton]="false" [showMatchModes]="true"
                                                [matchModeOptions]="matchModeOptions" [showOperator]="false"
                                                [showClearButton]="false" [showApplyButton]="false">
                                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                                    <input #modifiedBy type="text"
                                                        value="{{filters?.modifiedBy[0]?.value}}" pInputText
                                                        class="pinputHeight">
                                                    <div class="p-d-flex p-jc-between p-ai-center p-mt-1">
                                                        <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-danger"
                                                            (onClick)="filter(undefined);applyFilterNew(dt2)">Clear
                                                        </p-button>
                                                        <p-button pRipple
                                                            styleClass="btn-height p-mt-2 p-p-2 bg-success"
                                                            (onClick)="filter(modifiedBy.value);applyFilterNew(dt2);filterModifiedBy.hide()">
                                                            Apply</p-button>
                                                    </div>
                                                </ng-template>
                                            </p-columnFilter>
                                        </th>


                                    </tr>
                                    <tr [hidden]="!showFilters">
                                        <th *ngIf="isShowColumns('action')"></th>
                                        <th *ngIf="isShowColumns('searchPageName')">
                                            {{filters?.searchPageName[0]?.value}}</th>
                                        <th *ngIf="isShowColumns('themeName')">
                                            {{filters?.themeName[0]?.value}}</th>
                                            
                                        <!-- <th *ngIf="isShowColumns('description')">
                                            {{filters?.description[0]?.value}}</th> -->
                                        <th *ngIf="isShowColumns('createdBy')">{{filters?.createdBy[0]?.value }}</th>
                                        <th *ngIf="isShowColumns('modifiedBy')">{{filters?.modifiedBy[0]?.value }}</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-searchPageThemeUsersList>
                                    <tr>
                                        <td *ngIf="isShowColumns('action')"> <a [routerLink]="" class="table-icon table-icon-menu"><i class="pi pi-ellipsis-v"
                                            (click)="selectedGridMenuItem = searchPageThemeUsersList;displayActionMenu(); menu.toggle($event)"></i></a>
                                    <p-menu #menu [popup]="true" [model]="items" appendTo="body"></p-menu>
                                </td>
                                        <td *ngIf="isShowColumns('searchPageName')">
                                            <span>{{searchPageThemeUsersList.searchPageName}}</span>
                                        </td>
                                        <td *ngIf="isShowColumns('themeName')">
                                            <span>{{searchPageThemeUsersList.themeName}}</span>
                                        </td>
                                        <td *ngIf="isShowColumns('description')">
                                            <span>{{searchPageThemeUsersList.description}}</span>
                                        </td>
                                        <td *ngIf="isShowColumns('createdBy')">
                                            <span>{{searchPageThemeUsersList.createdByName}}</span>
                                        </td>
                                        <td *ngIf="isShowColumns('modifiedBy')">
                                            <span>{{searchPageThemeUsersList.modifiedByName}}</span>
                                        </td>

                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td [attr.colspan]="selectedColumns.length">No Data found.</td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>
                    <!-- <br>
                    <br>
                    <br>
                    <br> -->
                </div>
            </div>
        </div>
    </div>
    <p-toast position="bottom-center"></p-toast>

</section>